import { render, staticRenderFns } from "./TextResourcesTable.vue?vue&type=template&id=519fc9a3&"
import script from "./TextResourcesTable.vue?vue&type=script&lang=ts&"
export * from "./TextResourcesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports